<template>
  <!-- red recepta u blokovima (Top recepti); izgled isti kao red oglasa (AdRow, assets/scss/adRow.scss) -->
  <article class="adr adr-solo noselect" :class="{ 'adr-noimg': !showImage }">
    <NuxtImg
      v-if="showImage"
      :src="$getImageSrc(recipe.img_cover)"
      :alt="recipe.title"
      fit="cover"
      width="60"
      height="60"
      loading="lazy"
      decoding="async"
      class="adr-img"
    />

    <!-- jedini link u redu (razvucen preko celog reda, vidi AdRow) -->
    <div class="adr-title">
      <NuxtLink :to="link" class="adr-link">{{ recipe.title }}</NuxtLink>
    </div>

    <span v-if="recipe.category_name" class="adr-meta adr-meta-cat">{{ recipe.category_name }}</span>

    <span v-if="recipe.video_link" class="adr-pill adr-pill-date">VIDEO</span>
  </article>
</template>

<script setup>
const props = defineProps({
  recipe: { type: Object, required: true },
  // false: red bez slike
  showImage: { type: Boolean, default: true },
})

const recipeLink = useRecipeLink()
const link = computed(() => recipeLink(props.recipe))
</script>
